import { AppBar } from "../components/AppBar";

/** Placeholder for screens built in phase 5. */
export function Stub(props: { title: string }) {
  return (
    <main class="screen bg-surface">
      <AppBar title={props.title} back="/map" />
      <p class="p-6 text-center text-text">Cette page n'existe pas.</p>
    </main>
  );
}
